export const meetupDate = '2025-10-23';
export const meetupStartTime = '13:00';
export const timeZone = 'CET';
export const formName = 'europe-digital-sovereignty-2025-frankfurt';
export const logoUrl =
  'https://andersenlab.com/?utm_source=sovereignty_frankfurt_am_main&utm_medium=event';

export const initialCoordinates = {
  lat: 50.112335328871325,
  lng: 8.717217198124459,
};

export const markerSettings = {
  position: initialCoordinates,
  icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/forum-bishkek/location/marker-for-map.svg',
  title: 'Europe: Digital Sovereignty or Dependence?',
  address: 'Nemos Suite, Hanauer Landstraße 154<br>60314 Frankfurt, Germany',
  link: 'https://www.google.com/maps/place/re:mynd+Eventlocation+und+Services/@50.1122578,8.7167129,19z/data=!3m1!4b1!4m6!3m5!1s0x47bd0f84863fcbbb:0x449bf5f93fb2c859!8m2!3d50.1122569!4d8.7173566!16s%2Fg%2F11fq7qlwmh?entry=ttu&g_ep=EgoyMDI1MDgxOS4wIKXMDSoASAFQAw%3D%3D',
};
